<powerbi-report
*ngIf="report"
    [embedConfig] = "reportConfig"
    [cssClassName]="customClass"
>
</powerbi-report>